/*
 * 扫描该目录下所有gpt-*.vue文件
 */
const requireFiles = require.context('.', true, /gpt-[\w-]+\.vue$/);

export default requireFiles.keys().map(fileName => {
    const componentConfig = requireFiles(fileName);
    return componentConfig.default || componentConfig;
});
